import ClientsList from "../components/aesthetics/clients/ClientsList";

export default function AestheticClientsPage() {
  return (
    <div className="">
      <ClientsList />
    </div>
  );
}
